const waitConditionLoop = (func, conditionFunc, interval) => {
  if (conditionFunc()) {
    func();
  } else {
    setTimeout(() => waitConditionLoop(func, conditionFunc, interval), interval);
  }
};

export default waitConditionLoop;
